import { render, staticRenderFns } from "./tahsilatdialog1.vue?vue&type=template&id=10ff5e39&"
import script from "./tahsilatdialog1.vue?vue&type=script&lang=js&"
export * from "./tahsilatdialog1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports